import "./styles.scss";
import * as React from "react";
import {Display} from "../../../components/Display";
import {Badge} from "@vebox/etui-core";
import {StyleProps, useTheme} from "@vebox/etui-system";
import {Theme} from "@vebox/etui-themes";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";

export enum STATUS_TEXTS {
    READING = "Reading",
    WRITING = "Writing",
    VALIDATING = "Validating",
    ERROR = "Error",
    FAILED = "Failed",
    COMPLETED = "Completed",
    CONCLUDED = "Concluded",
    NONE = "None",
    IN_PROGRESS = "In Progress"
}


interface StatusChipProps {
    status: STATUS_TEXTS;
    customLabel?: string;
    badgeStyle?: StyleProps
    boxStyle?: React.CSSProperties
}

interface Status {
    label: string | STATUS_TEXTS;
    color: string;
}

export const getStatusColor = (status: STATUS_TEXTS, theme: Theme): string => {
    switch (status) {
        case STATUS_TEXTS.READING:
            return theme.palette.purple[100];
        case STATUS_TEXTS.WRITING:
            return theme.palette.deepRed[100];
        case STATUS_TEXTS.VALIDATING:
            return theme.palette.blue[100]
        case STATUS_TEXTS.ERROR:
        case STATUS_TEXTS.FAILED:
            return theme.palette.red[100]
        case STATUS_TEXTS.COMPLETED:
        case STATUS_TEXTS.CONCLUDED:
            return theme.palette.green[100]
        case STATUS_TEXTS.IN_PROGRESS:
            return theme.palette.turquoise[100]
        default:
            return theme.palette.grey[20];
    }
}

const getStatus = (status: STATUS_TEXTS, theme: Theme, getStatusText: (status: STATUS_TEXTS) => string,
                   customLabel?: string): Status => {
    switch (status) {
        case STATUS_TEXTS.READING:
        case STATUS_TEXTS.WRITING:
        case STATUS_TEXTS.VALIDATING:
        case STATUS_TEXTS.ERROR:
        case STATUS_TEXTS.IN_PROGRESS:
        case STATUS_TEXTS.COMPLETED:
        case STATUS_TEXTS.CONCLUDED:
        case STATUS_TEXTS.FAILED:
            return {label: customLabel ?? getStatusText(status), color: getStatusColor(status, theme)};
        default:
            return undefined
    }
}
export const StatusChip: React.FC<StatusChipProps> = ({status, customLabel, boxStyle, badgeStyle}) => {
    const theme = useTheme();
    const {getStatusText} = React.useContext(ReadAndWriteContext)


    const chipStatus = getStatus(status, theme as Theme, getStatusText, customLabel);
    return (
        <Display isVisible={chipStatus && status !== STATUS_TEXTS.NONE}>
            <div className={"status-chip"} style={boxStyle}>
                <Badge
                    text={chipStatus?.label}
                    size={"sm"}
                    animationDisabled={false}
                    styles={{root: {bg: chipStatus?.color, fontWeight: 'bold', ...badgeStyle}}}
                />
            </div>
        </Display>
    );
}